import type { BdsSelectProps } from "@buildertrend/components";

import type { BTSelectProps } from "commonComponents/btWrappers/BTSelect/BTSelect";

/** Auto-generated ID prefix for select group headers that don't have explicit IDs */
export const BTSelectGroupHeaderId = "selectGroupAutoId";

/**
 * Discriminated union for wrappers that conditionally render `BTSelect` or `BdsSelect`
 * based on a `useBds` flag. Narrows to `BTSelectProps` when `useBds` is omitted/false,
 * and to `BdsSelectProps` when `useBds` is `true`.
 */
export type BTOrBdsSelectProps<FormValues, ExtraDataType> =
    | ({ useBds?: false } & BTSelectProps<FormValues, ExtraDataType>)
    | ({ useBds: true } & BdsSelectProps<FormValues, ExtraDataType>);
